import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface IntegrationPopupHeaderProps {
  iconSrc?: string
  iconElement?: React.ReactElement | null
  title: React.ReactNode
  subtitle: React.ReactNode
}

const IntegrationPopupHeader: React.FC<IntegrationPopupHeaderProps> = (
  props,
): React.ReactElement => {
  return (
    <div
      css={css`
        background-color: ${styleConstants.colors.gray_light};
        padding: 60px 60px 40px;
        border-top-left-radius: ${styleConstants.borderRadius.box};
        border-top-right-radius: ${styleConstants.borderRadius.box};
        border-bottom: 1px solid ${styleConstants.colors.gray_medium};
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        `}
      >
        {props.iconElement ? (
          <span
            css={css`
              width: 60px;
              height: 60px;
              margin-right: 20px;
              display: inline-flex;
              align-items: center;
              justify-content: center;

              svg {
                width: 100%;
                height: 100%;
              }
            `}
            aria-hidden="true"
          >
            {props.iconElement}
          </span>
        ) : (
          props.iconSrc && (
            <img
              src={props.iconSrc}
              css={css`
                width: 60px;
                margin-right: 20px;
              `}
              alt={''}
            />
          )
        )}
        <span
          css={css`
            ${getFontCss(
              32,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
          `}
        >
          {props.title}
        </span>
      </div>
      <p
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {props.subtitle}
      </p>
    </div>
  )
}

export default IntegrationPopupHeader
